import GameStatesEnum from "../GameStatesEnum"
import BaseState from '@state/BaseState'
import Signals from "@/signals/GameSignals";
import Facade from "@/Facade";

export default class FinalState extends BaseState {

    begin() {
        console.log('  FinalState  fs =  ', this.model.isFreespinsStarted, 'bonus  ', this.model.isBonusStarted)
        this.gameState = GameStatesEnum.IDLE

        if (this.model.countAmountFreeBet > 0 && !this.model.isFreespinsStarted) {
            this.gameState = GameStatesEnum.FREE_SPINS_INTRO
        }

        if (this.model.countAmountFreeBet  === 0 && this.model.isFreespinsStarted) {
            this.gameState = GameStatesEnum.OUTRO_FREESPINS
        }

        if (this.model.stateSkipped) { //|| this.model.stateSkippedWinnings) {
            console.log('  FinalState   skip ', this.model.stateSkipped, this.model.stateSkippedWinnings)
            this.end()
            return
        }

        console.log('FinalState    winnings: ', this.model.winnings, '    freebetCount : ',this.model.bonus.freebetCount )
        //winBonusAmountCurrency > 0
        if (this.model.winnings && this.model.winnings.length > 0 || this.model.bonus && this.model.bonus.freebetCount > 0)
        {
            if (this.model.totalWin > 0 || this.model.bonus.freebetCount > 0) {
                this.gameState = GameStatesEnum.SHOW_WINNINGS
            }
        }

/*
        console.log('FinalState    winnings: ', this.model.winnings, '    freebetCount : ',this.model.bonus.freebetCount )
        if (this.model.winnings && this.model.winnings.length > 0 || this.model.bonus &&
         this.model.bonus.freebetCount > 0 // || this.model.scatters
         ) {

            if (this.model.totalWin > 0 || this.model.bonus.freebetCount > 0// || this.model.scatters
            ) {
                this.gameState = GameStatesEnum.SHOW_WINNINGS
            }
        }
*/
        this.end()
    }

    end = () => {
        this.stateMachine.setState(this.gameState)
    }
}
